module.exports = __webpack_public_path__ + "img/banner7.ff3a9658.png";